import LanguageMessages from "./LanguageMessages";

const frenchMessages: LanguageMessages = {
    NavBar: {
        HomeTitle: 'Home',
        AccordionsTitle: 'Accordéons',
        ContactTitle: 'Contact',
        CompanyTitle: 'Entreprise',
        TeamTitle: 'Équipe',
        LogoutTitle: 'Déconnexion',
        AccessoriesTitle: 'Accessoires',
    },
    RollingCredits: {
        DialogTitle: 'Gérer le texte',
    },
    Footer: {
        firm: "Firma",
        addressLineOne: "Generalvertretungen Schweiz",
        addressLineTwo: "PIGINI & EXCELSIOR",
        addressLineThree: "Martin Frey",
        address: "Untere Holzstrasse 9",
        plz: '5036',
        city: 'Oberentfelden',
        telephone: 'Festnetz: +41 62 827 21 61',
        mobile: 'Mobil: +41 79 239 77 94',
        emailLabel: 'E-Mail:',
        email: 'info@pigini.ch'
    },
    HomePage: {
        HomeShopShortcut: {
            titleText: 'Explorez notre belle sélection d\'accordéons, comprenant des pièces soigneusement sélectionnées de Pigini et Excelsior Accordions. Vivez le charme et l\'artisanat de ces instruments magnifiquement conçus. Immergez-vous dans le monde de ces instruments artistiques et magnifiquement conçus.'
        }
    },
    TeamPage: {
        title: 'Equipé',
        teamMembers: [
            {
                name: 'Martin Frey',
                text: [
                    '',
                    '[[[bold]]]Entraînement',
                    'Département universitaire de génie civil (Brugg-Windisch / CH)',
                    '- Dipl. Ingénieur Civil HTL (puis FH)',
                    'Études de troisième cycle: ',
                    '- MAS-ND-U (Gestion d\'entreprise / Haute école spécialisée de Lucerne à Horw / CH)',
                    '- MAS-CIM (Fabrication Intégrée par Ordinateur / Brugg-Windisch / CH)',
                    '',
                    '[[[bold]]]Chef de projet & Ingénierie',
                    'De nombreuses années d\'expérience dans le génie civil national et la construction de bâtiments, une expérience internationale dans l\'industrie de la construction mécanique (y compris la production d\'accordéons), l\'industrie des équipementiers automobiles, la technologie aérospatiale et la robotique. De nombreuses années d\'expérience dans des projets nationaux et internationaux de conseil, de modélisation et de simulation de processus (Aeneis, Six-Sigma, Wassermann {process simulation} SAP-R3), systèmes SOX et IKS.',
                    'Projets de procédés nationaux et internationaux dans de grandes entreprises de production d\'énergie.',
                    '',
                    '[[[bold]]]Expériences musicales internationales',
                    'Organisateur de concerts et de séminaires dans diverses directions et genres, dont des concerts d\'accordéon. (Friedrich Lips, Viacheslav Semjonov, Yuri Shishkin, Frank Marocco, Timbre Russian Accordions Group de Moscou, Pavel Smirnov Orchestra, New Zealand Accordion Orchestra, Frank Marocco, Fang Yuan, entre autres)',
                    '',
                    '[[[bold]]]Agence générale d\'accordéons',
                    'Pour le premier fabricant mondial d\'accordéons haut de gamme des marques PIGINI & EXCELSIOR',
                    '- 35 ans de Suisse & Liechtenstein (propriétaire de l\'agence générale)',
                    '- Environ 10 ans en Russie (gestion opérationnelle de l\'agence générale)'
                ]
            }
        ]
    },
    CompanyPage: {
        AboutUs: {
            title: 'Qui sommes nous',
            pAndSSwitzerland: {
                subtitle: 'PIGINI & EXCELSIOR Suisse',
                text:  'State-of-the-Art dans la construction d\'accordéons. Harmonie parfaite avec la tradition, innovation et qualité. PIGINI compte sans compromis sur l\'expérience des facteurs d\'instruments italiens.',
            },
            relationships: {
                subtitle: 'Communion',
                text: 'Pour produire les meilleurs instruments, PIGINI travaille en étroite collaboration avec des solistes mondialement connus, orchestres , conservatoires, écoles d\'accordéons et professeurs d\'accordéon. Ce réseau mondial que PIGINI partage avec ces agences générale font le succès de nos instruments.',
            },
            since: {
                subtitle: 'PIGINI & EXCELSIOR Suisse depuis 1990',
                text: 'En 1990 la représentation générale pour le marché Suisse a adhéré à la philosophie de PIGINI & EXCELSIOR. Depuis lors elle se porte garante pour la qualité supérieure des instruments ainsi que le service à la clientèle due pour des instruments d\'une telle qualité.\n' +
                    '\n' +
                    'Nous sommes fiers de pouvoir vous proposer des accordéons qui ne laissent aucun doute sur leur sonorité et la qualité.',
            },
            ourService: {
                subtitle: 'Notre Service',
                text: 'N\'hésitez pas à nous contacter, nous vous conseillerons avec honnêté et sérieux pour l\'achat ou la location d\'un instrument en respectant vos désirs spéciaux.'
            },
            comeSee: {
                subtitle: 'Essais',
                text: 'Contactez nous pour prendre rendez-vous et jouer nos instruments pour trouver le son et la taille qui vous convient le mieux. Chez le représentant général vous serez reĉus par des passionés d\'accordéon. Nous nous réjouissons de votre visite dans notre monde et vous souhaitons la bienvenue.',
            },
        },
        AboutPigini: {
            title: 'L\'Histoire de Pigini',
            tradition: {
                subtitle: 'Tradition',
                text: 'Le 6 juin 1946 Filippo Pigini a fondé la maison "F.lli PIGINI di Filippo" avec ses fils Adrian, Gino, Luigi et Marino Pigini comme associé à la chambre de commerce de Ancona. Filippo PIGINI, un homme avec un esprit entrepreneur, assura le redémmarage de la menuiserie creacute;e en 1930 par ses enfants qui revenaient du front de la guerre. A ce moment la les premiers Accordéons furent produits.'
            },
            foundingYears: {
                subtitle: 'Année de création',
                text: 'L\'après guerre fut difficile, mais les frères et sœurs ne se sont pas laisser aller. La nécessité de gagner leur vie et la passion les ont poussés à créer une des entreprises des plus dynamiques de construction d\'accordéon. Les premières livraisons partirent aux USA, ensuite au Canada, Suède, Danmark, Argentine, Egypte et Pakistan. Ceci montrant déjà la voie de leur esprit international qui est toujours présent chez PIGINI.',
            },
            ginoPigini: {
                subtitle: 'Gino Pigini',
                text: 'C\'est Gino Pigini qui a dirigé pendant plusieurs année l\'entreprise. Il était déjà à l\'age de 14 ans un "Vociarolo" (constructeur d\'anches) expérimenté. Il fesait confiance à la jeunesse et à la volonté d\'apprendre et d\'innovation. En peu de temps il a crée un groupement de constructeur d\'accordéons. Ses efforts ainsi sa philosophie du travail sont encore à nos jours les bases pour la qualité supérieure de instruments PIGINI.',
            },
            philosophy: {
                subtitle: 'Philosphie de l\'entreprise',
                text: 'Analyser le futur pour capitaliser le passé. C\'est avec cet esprit PIGINI prend tous les défis à coeur. On regarde l\'accordéon comme instrument avec passion et amour. La connaissance, la technique et du savoir faire sont de mise depuis des décennies.\n' +
                    '\n' +
                    'La renommée mondiale fait que les académies de musique et les virtuoses d\'accordéon ont donné leur préférences à nos instruments. Cette renommée est surtout due à la stabilité de notre qualité qui nous a propulsé en tant que leader dans cette branche.',
            },
            craftsmanship: {
                subtitle: 'Fabrication manuelle',
                text: 'Le respect des traditions, en utilisant les techniques les plus modernes, font développer encore plus les expertises acquises pendant des centenaires pour pouvoir atteindre des horizons encore plus larges.'
            },
            topQualityMaterials: {
                subtitle: 'Qualité du matériel',
                text: 'Chaque instrument PIGINI est un œuvre construite avec des matériaux spéciaux. Le bois est choisi avec soin. Les anches, l\'âme de l\'instrument, sonf fabriqués à l\'usine (selon le modèle à la main) et connues par le monde pour leur excellente qualité. Toutes les autres pièces de l\'instrument , feutres, laques, cuir etc. sont fabriqués avec les meilleurs matériaux donnant des instruments de première qualité.',
            },
            careForDetail: {
                subtitle: 'Soin du détail',
                text: 'Le son pur et puissant est du à la réduction du bruit de chaque élément mécanique. C\'est pour cette raison que les instruments PIGINI sont pourvus de coussinets d\'amortissement. Le bruit est atténué au maximum pour produir un son pur que les spécialistes reconaissent immédiatement.',
            },
            selection: {
                subtitle: 'Gamme élargie',
                text: 'Le catalogue PIGINI offre plus de 60 différents modèles pour couvrir toutes les exigences des musiciens. L\'instrument de musique doit s\'adapter aux demandes des jeunes débutants jusqu\'au musicien de concert. Tous les besoins sont pris en compte pour être en mesure de satisfaire aussi bien les besoins des amateurs et des débutants que ceux des professionnels les plus affirmés.',
            },
            qoi: {
                subtitle: 'Longévité',
                text: 'La qualité de la manufacture et l\'utilisation de matiériaux exclusifs font que chaque PIGINI-Accordéon s\'avère être un bon investissement pour de longues années. Vu que chaque accordéon est une pièce unique sa valeur peut que augmenter durant les années.',
            },
            uniqueness: {
                subtitle: 'Singularité',
                text: 'Une vis isolée, les découpes de bois, l\'équilibre des proportions, la solidité des feutres, la précision des leviers, le calibrage des ressorts. Chacun chez PIGINI s\'efforce pour atteindre la perfection de tout ces petits détail invisibles mais si importants au toucher.',
            },
            touch: {
                subtitle: 'Touche',
                text: 'Derrière la bonne rénommée des Instruments PIGINI il y a toujours la recherche de l\'excellence du son pour satisfaire la musique et les attentes des musiciens. Il en résulte que chaque instrument PIGINI se joue avec plaisir donnant un sens particulier. L\'accordéon PIGINI, au centre de chaque concert, s\'enrichit de la virtuosité comme un phoète des ses vers.',
            }
        },
        AboutExcelsior: {
            title: 'L\'Histoire de Excelsior',
            beginnings: {
                subtitle: 'Les débuts',
                text: 'Excelsior à été fondée à New York en 1924. L\'excellente qualité des accordéons fabriqués par Excelsior les a rendus vite populairs à travers tous les Etats Unis. Le sommet de la popularité fut atteint après la deuxième guerre mondiale lorsque tous les grands orchestres s\'équipèrent avec des Instruments Excelsior. Des artistes tel que Charles Magnante, Art Van Damme et Piero Deiro parmis tant d\'autres avaient porté leur choix sur Excelsior.',
            },
            expansion: {
                subtitle: 'Expension',
                text: '1948 une nouvelle usine à été bâtie à Castelfidardo, Italie, ceci pour augmenter la capacité de production et de vente. Depuis lors l\'excellente qualité et prestations des accordéons Excelsior est appréciée mondialement.',
            },
            heritage: {
                subtitle: 'L\'héritage',
                text: 'La tradition de qualité et prestige continue a être maintenue par Excelsior. Comme dans le passé les instruments Excelsior sont fabriqués avec des matériaux sélectionnés et du savoir faire.\n' +
                    '\n' +
                    'Posséder un accordéon Excelsior exprime aujourd\'hui l\'envie d\'imiter des meilleurs virtuoses d\'accordéon du passé et du présent.',
            },
        },
        Consultations: {
            title: 'Conseils',
            appointments: {
                subtitle: 'Délais',
                text: 'Es-ce que nous avons réveillé votre intérêt? Si c\'est le cas, contactez-nous pour un éssai sans autre à notre siège à Oberentfelden. Nous nous réjouissons de votre visite.'
            },
            wideSelection: {
                subtitle: 'Grand choix',
                text: 'Nous avons une quantité d\'instruments de Pigini et d\'Excelsior en stock qui sont à votre disposition pour vous familiariser et être testés par vos soins. Ça vous assurera que votre choix se portera sur un instrument qui vous convient le mieux.',
            },
            service: {
                subtitle: 'Conseils sérieux et compétents',
                text: 'Ayant joué pendant des décennies à l\'accordéon et entretenant des excellents rapports avec des Accordéonistes virtuoses connus mondialement, Mr. Martin Frey est d\'un excellent conseil pour vous aider à choisir l\'instrument qu\'il vous faut.',
            }
        },
        Rentals: {
            title: 'Location d\'Instruments',
            subtitle: 'Quand un achat ne vaut pas la peine',
            text: 'Pour un enfant en pleine croissance il est souvent déconseillé d\'acquérir un instrument. Nous vous offrons une palette d\'instruments à louer qui peu satisfaire au besoin de croissance des élèves.',
        },
        Repairs: {
            title: 'Réparations',
            subtitle: 'Si jamais il y avait des...',
            text: 'Après achat nous sommes à votre disposition pour toute intervention, réparation, modification des sonorités ou toute autres demandes. Nous vous offrons un service rapide et compétent.',
        }
    },
    ContactPage: {
        ContactUsCardTitle: 'Envoyer demande\n',
        ContactUsCardDescription: 'Nous sommes également joignables par e-mail: [[[mailto]]]info@pigini.ch ou par téléphone: +41 79 239 77 94',
        areasOfInterest: {
            areasOfInterestTitle: 'Interêts',
            sendFurtherInformationChecboxLabel: 'Veuillez m\'envoyer une documentation de vos instrument sans engagement.',
            contactMeForTryOutCheckboxLabel: 'Veuillez me contacter pour prendre rendez-vous pour un essai de vos instruments.',
            interestedInRentingCheckboxLabel: 'Je désire louer un instrument. Veuillez me contacter pour plus d\'informations.'
        },
        contactInformation: {
            titleLabel: 'titre',
            titleMrValueLabel: 'Monsieur',
            titleMsValueLabel: 'Madame',
            firstNameLabel: 'prénom',
            lastNameLabel: 'nom',
            streetLabel: 'rue',
            houseNumberLabel: 'numéro de maison',
            zipLabel: 'code postal',
            cityLabel: 'bourgade',
            phoneLabel: 'téléphone fixe',
            mobileLabel: 'mobil',
            emailLabel: 'E-Mail',
            preferredMethodOfContactLabel: 'méthode du contact préféré',
            additionalInformationTitle: 'additional comments (optional)',
            sendButtonLabel: 'send'
        }
    },
    AccordionsPage: {
        titleToBuy: 'Accordéons à acheter',
        titleToRent: 'Accordéons à louer',
        Filter: {
            resetFilterBtnLabel: 'Remittre le filtre',
            brandTitle: 'Marque',
            generalCategoryTitle: 'Général',
            rightHandCategoryTitle: 'Main droite',
            leftHandCategoryTitle: 'Main gauche',
            standardBassCategoryTitle: 'Basse Standard',
            characteristicsCategoryTitle: 'Caractéristiques',
            freeBassCategoryTitle: 'Basse Libre',
            isRental: 'Location',
            Condition: {
                title: 'État',
                used: 'D\'occasion',
                new: 'Neuf',
            },
            BassType: {
                title: 'Système basse',
                convertor: 'Convertor',
                standard: 'Standard',
            },
            RightHandSystem: {
                title: 'Système',
                keys: 'Piano',
                buttons: 'Bouton'
            },
            Weight: {
                title: 'Poids'
            },
            Height: {
                title: 'Hauteur'
            },
            Width: {
                title: 'Largeur',
            },
            Rows: {
                title: 'Rangées'
            },
            RightHandButtons: {
                title: 'Notes de boutons',
            },
            ChorusRight: {
                title: 'Chorus'
            },
            CassottoRight: {
                title: 'Cassotto',
            },
            RegisterRight: {
                title: 'Registres'
            },
            ChinSwitches: {
                title: 'Commutateurs de menton'
            },
            StandardBassChorus: {
                title: 'Chorale',
            },
            RegisterSb: {
                title: 'Registres'
            },
            FreeBassNotes: {
                title: 'Notes',
            },
            ChorusFb: {
                title: 'Chorus',
            },
            RightNotesPiano: {
                title: 'Notes de piano',
            },
            ReedsFilter: {
                title: 'Anches',
                tam: 'Tipo a Mano',
                fam: 'Fait à la Main',
                durall: 'Durall',
                turbo: 'Turbo',
                none: 'Aucune'
            }
        },
        DeleteAccordion: {
            ConfirmationDialogTitle: 'Supprimer l\'accordéon',
            ConfirmationDialogContent: 'Êtes-vous sûr de vouloir supprimer l\'accordéon ? Une fois supprimé, vous devrez contacter l\'administrateur pour le restaurer. Des données peuvent encore être perdues pendant ce processus.',
        },
        PublishAccordion: {
            ConfirmationDialogTitle: 'Publier l\'accordéon',
            ConfirmationDialogContent: 'Êtes-vous sûr de vouloir publier l\'accordéon ? Une fois publié, tout le monde pourra voir cet accordéon dans le magasin. Seul l\'administrateur peut le « dépublier ».',
        },
        UnpublishAccordion: {
            ConfirmationDialogTitle: 'Dépublier l\'accordéon',
            ConfirmationDialogContent: 'Êtes-vous sûr de vouloir dépublier cet accordéon ? Après cette action, le public ne pourra plus voir cet accordéon, jusqu\'à ce qu\'il soit publié à nouveau.',
        },
        ImageManager: {
            setAsThumbnailButtonLabel: 'Définir comme vignette'
        },
        accordionNotFoundText: 'Accordéon non trouvé',
        accordionAdditionalInformationContactText: 'Je m\'intéresse à l\'accordéon',
    },
    AccessoriesPage: {
        title: 'Accessoires',
        subtitle: 'Découvrez les compléments parfaits pour enrichir votre expérience avec l\'accordéon grâce à notre large sélection d\'accessoires. Si quelque chose vous intéresse, n\'hésitez pas à nous contacter directement. De plus, si vous recherchez un accessoire spécifique qui n\'est pas présent dans notre collection, n\'hésitez pas à nous contacter. Nous nous engageons à répondre à vos besoins et à vous assurer de trouver exactement ce que vous cherchez.',
        Backpacks: {
            title: 'Sacs à dos',
            text: 'Rehaussez votre parcours musical avec nos sacs à dos de haute qualité conçus spécifiquement pour les accordéons et les CH-Örgeli. Ces sacs à dos offrent plus que de la commodité de transport; ils assurent une protection robuste et un design élégant qui complète votre instrument. Que vous soyez un musicien professionnel ou un passionné, nos sacs à dos garantissent que votre accordéon ou CH-Örgeli voyage dans le confort et le style. Explorez notre gamme de sacs à dos qui incarnent la durabilité, l\'élégance et des détails pratiques.',
            tableData: {
                columnNameDef: [],
                columnKeyDef: ['text', 'currency', 'price' ],
                rows: [
                    { text: 'Sac à dos accordéon cordura'           , price: 'À partir de 63'  , currency: 'CHF / Euro' },
                    { text: 'Sac à dos Schwyzerörgeli'              , price: 'À partir de 90'  , currency: 'CHF / Euro' },
                    { text: 'Sac de transport souple pour accordéon', price: 'À partir de 70'  , currency: 'CHF / Euro' },
                ]
            }
        },
        ShoulderStraps: {
            title: 'Bretelles',
            text: 'Découvrez notre gamme variée de bretelles pour accordéons, disponibles avec ou sans sangle croisée. Conçues pour répondre aux besoins spécifiques de chaque musicien, nos bretelles sont disponibles en différentes tailles pour assurer un ajustement parfait et un confort inégalé. Que vous préfériez la stabilité améliorée d\'une sangle croisée ou la simplicité d\'un design traditionnel, nos bretelles offrent le soutien nécessaire pour jouer de votre instrument avec aisance et élégance.',
            tableData: {
                columnNameDef: ['', '', '', 'Prix'],
                columnKeyDef: ['text', 'paddingWidth', 'currency', 'price' ],
                rows: [
                    { text: 'Bandoulière accordéon sans bretelles croisées'     , price: 'À partir de  50', currency: 'CHF / Euro'  , paddingWidth: '45 mm' },
                    { text: 'Bandoulière accordéon avec bandoulière croisée'    , price: 'À partir de  79', currency: 'CHF / Euro'  , paddingWidth: '50 mm' },
                    { text: 'Bandoulière accordéon avec bandoulière croisée'    , price: 'À partir de 100', currency: 'CHF / Euro'  , paddingWidth: '70 mm' },
                    { text: 'Bandoulière accordéon avec bandoulière croisée'    , price: 'À partir de 100', currency: 'CHF / Euro'  , paddingWidth: '80 mm' },
                ]
            }
        },
        AccordionDustCovers: {
            title: 'Housses de protection',
            text: 'Protégez votre accordéon contre la poussière et les petites éraflures avec notre sélection de housses de protection, disponibles en tailles petite, moyenne et adaptées pour les convertisseurs. Ces housses sont conçues pour offrir un ajustement parfait, garantissant une protection complète de votre instrument. Idéales pour le rangement et la protection quotidienne, nos housses de protection préservent l\'état impeccable de votre instrument de musique lorsqu\'il n\'est pas utilisé. Explorez notre gamme pour trouver la housse idéale répondant à vos besoins.',
            tableData: {
                columnNameDef: ['', '', 'Prix'],
                columnKeyDef: ['text', 'currency', 'price' ],
                rows: [
                    { text: 'Housse de protection accordéon petite'     , price: '20', currency: 'CHF / Euro' },
                    { text: 'Housse de protection accordéon médium'     , price: '20', currency: 'CHF / Euro' },
                    { text: 'Housse de protection accordéon grande'     , price: '20', currency: 'CHF / Euro' },
                ]
            }
        },
        AccordionGloveLeftHand: {
            title: 'Gant accordéon pour la main gauche',
            text: 'Profitez d\'un confort et d\'un contrôle accrus avec notre Gant pour la Main Gauche spécialement conçu pour les joueurs d\'accordéon. Inventé à l\'origine pour protéger la main du musicien contre la friction constante et la pression des boutons de basse, ces gants aident également à maintenir une température constante, évitant que la transpiration n\'affecte la performance. Notre Gant pour la Main Gauche est fabriqué à partir de matériaux de haute qualité qui garantissent à la fois durabilité et flexibilité, vous permettant de jouer pendant de longues périodes sans inconfort.',
            tableData: {
                columnNameDef: ['', '', 'Prix'],
                columnKeyDef: ['text', 'currency', 'price' ],
                rows: [
                    { text: 'Gant de protection accordéon main gauche', price: '35', currency: 'CHF / Euro' }
                ]
            }
        }
    },
    ConfirmationDialog: {
        DefaultDialogTitle: 'Veuillez confirmer',
        DefaultDialogContent: 'Veuillez confirmer votre action proposée'
    },
    GeneralComponentLabels: {
        notes: 'Notes',
        range: 'Gamme',
        from: 'de',
        to: 'à',
        deleteButtonLabel: 'supprimer',
        cancelButtonLabel: 'annuler',
        createButtonLabel: 'Créer',
        publishButtonLabel: 'Publier',
        unpublishButtonLabel: 'Dépublier',
        manageImagesButtonLabel: 'Gérer les images',
        closeButtonLabel: 'Fermer',
        backButtonLabel: 'Retour',
        speed: 'Vitesse',
        price: 'Prix',
        product: 'Produit',
        currency: 'Monnaie',
        paddingWidth: 'Largeur du rembourrage'
    },
    ShopShortcut: {
        buy: 'Acheter',
        rent: 'Louer',
    }
}

export default frenchMessages;
